// extracted by mini-css-extract-plugin
export var container = "intro-module--container--5ijdm";
export var img = "intro-module--img--RUvdN";